import React from 'react'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import { useScrollSelector } from '@gluedigital/scrollastic'
import './Features.sass'

const Features = () => {
  const step = useScrollSelector('.feature-step', { boundary: '-45vh' })
  const featuresList = ['js', 'access', 'security', 'create']
  const steps = featuresList.map((step, i) => {
    return (
      <div key={i} id={step} className="feature-step" />
    )
  })
  const features = featuresList.map((feature, i) => {
    return (
      <div key={i} id={`feature-${feature}`} className={'feature ' + (step === feature ? step : '')}>
        <div className="feature-card">
          <header>
            <div id={`feature-${feature}-symbol`} className="symbol" />
            <h2>
              <MarkdownMessage id={`feature.${feature}.title`} />
            </h2>
          </header>
          <FormattedMessage id={`feature.${feature}.text`}>
            {txt => txt.split('\n').map((l, j) => <p key={j}>{l}</p>)}
          </FormattedMessage>
        </div>
      </div>
    )
  })
  const dots = featuresList.map((feature, i) => {
    return (
      <a href={`#${feature}`} key={i} id={`dot-${feature}`} className={'dot ' + (step === feature ? step : '')} />
    )
  })

  return (
    <section className="section" id="features">
      <div className="features-content">
        <div className="container">
          <div className="split">
            <div className="item left">
              <h1>
                <MarkdownMessage id="home.features.title" />
              </h1>
            </div>
            <div className="item right">
              <div className="dots">
                {dots}
              </div>
              {features}
            </div>
          </div>
        </div>
      </div>
      {steps}
    </section>
  )
}

export default Features
